import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RACKEO_COUNTRIES, RACKEO_SITE } from '../rackeo-site';

@Injectable({
  providedIn: 'root'
})
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  set(path: string): void {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const canonicalUrl = RACKEO_SITE.baseUrl.replace(/\/$/, '') + normalizedPath;

    this.setCanonicalLink(canonicalUrl);
    this.setHreflangLinks(normalizedPath);
  }

  private setCanonicalLink(url: string): void {
    let link = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.document.head.appendChild(link);
    }
    link.setAttribute('href', url);
  }

  private setHreflangLinks(path: string): void {
    this.document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());

    for (const { localeId, baseUrl } of RACKEO_COUNTRIES) {
      const link = this.document.createElement('link');
      link.setAttribute('rel', 'alternate');
      link.setAttribute('hreflang', localeId);
      link.setAttribute('href', baseUrl + path);
      this.document.head.appendChild(link);
    }

    const xDefault = this.document.createElement('link');
    xDefault.setAttribute('rel', 'alternate');
    xDefault.setAttribute('hreflang', 'x-default');
    const clDefault = RACKEO_COUNTRIES.find(c => c.code === 'CL');
    xDefault.setAttribute('href', (clDefault?.baseUrl ?? 'https://www.rackeo.cl') + path);
    this.document.head.appendChild(xDefault);
  }
}
